'use client';
import React, { useState, useEffect } from 'react';
import Mydata from '../../data/blog/forthwroth.json';
import style from '@/app/style/servicesetyle.module.css';
import Sticky from '@/app/blog/business-travellers-car-service-dallas/sticky';
import { IoIosArrowDown } from 'react-icons/io';

const data = {
  dfwAirport: [
    {
      title: 'A Brief Introduction to DFW Airport',
      id: 'a-brief-introduction-to-dfw-airport', // ID based on title
      title1: 'Terminals at DFW',
      id1: 'terminals-at-tFW',
      terminals: [
        { name: 'Terminal A', id: 'terminal-a' },
        { name: 'Terminal B', id: 'terminal-b' },
        { name: 'Terminal C', id: 'terminal-c' },
        { name: 'Terminal D', id: 'terminal-d' },
        { name: 'Terminal E', id: 'terminal-e' },
      ],
    },
    {
      title: 'Navigation between the terminals',
      id: 'navigation-between-the-terminals', // ID based on title
      title1: '',
      terminals: [
        { name: 'The Skylink Train', id: 'the-skylink-train' },
        {
          name: 'The Terminal Link shuttle bus',
          id: 'the-terminal-link-shuttle-bus',
        },
      ],
    },
    {
      title: 'Travel Lounges at DFW',
      id: 'travel-lounges-at-dfw', // ID based on title
      title1: 'Hotels and Accommodations',
      id1: 'hotels-and-accommodations',
      terminals: [
        { name: 'Grand Hyatt DFW', id: 'grand-hyatt-dfw' },
        { name: 'Hyatt Regency DFW', id: 'hyatt-regency-dfw' },
      ],
    },
    {
      title: 'Transportation to and from DFW',
      id: 'transportation-to-and-from-dfw', // ID based on title
      terminals: [
        { name: 'Private Car Services', id: 'private-car-services' },
        {
          name: 'Airport Parking for Pick-ups',
          id: 'airport-parking-for-pick-ups',
        },
        {
          name: 'Dallas Area Rapid Transit (DART)',
          id: 'dallas-area-rapid-transit-dart',
        },
        {
          name: 'Trinity Railway Express (TRE)',
          id: 'trinity-railway-express-tre',
        },
      ],
    },
    {
      title: 'Conclusion',
      id: 'conclusion', // ID for conclusion
    },
  ],
};

function Hero() {
  // Assuming the JSON structure you've shared is stored in `data[0]`.
  const blogData = Mydata[0];
  const { dfwAirport } = data;
  // State to toggle the content
  const [isExpanded, setIsExpanded] = useState(true);

  // UseEffect to check screen size on load
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        // Example breakpoint for mobile view
        setIsExpanded(false);
      } else {
        setIsExpanded(true);
      }
    };

    // Run the function initially
    handleResize();

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Toggle function to expand/collapse the content
  const handleToggle = () => {
    setIsExpanded((prev) => !prev);
  };
  return (
    <>
      <div id={style.blogsiz} className={`flex items-end   ${style.blogguid}`}>
        <div className=" opecit w-full ">
          <div
            className=" mb-8 w-full  
       mx-auto px-4 max-w-7xl px-3 "
          >
            <p className="bg-[#d5af34] p-2 mb-2 rounded-lg inline-block">
              Airport Car Service
            </p>
            <h1 className="serviceh1">
              A Guide to Dallas Fort Worth
              <br />
              <span className="main_color"> International Airport (DFW)</span>
            </h1>
          </div>
        </div>
      </div>
      <div className=" flex justify-between  mx-auto max-w-7xl px-4 pt-4">
        <div className="border-1 px-4 rounded-lg border-[#2B3252] text-[#2B3252]">
          Est. Reading Time: 14 mins 14 sec
        </div>
        <div>
          <div className="bg-[#2B3252] text-white px-2 p-1 rounded-lg">
            21 Nov 2024
          </div>
        </div>
      </div>
      <div className=" flex justify-end  mx-auto max-w-7xl pt-10 px-6 ">
        <Sticky />
      </div>

      <div className="mx-auto max-w-5xl px-6 ">
        <p
          className="blogcontent mb-4"
          dangerouslySetInnerHTML={{ __html: blogData.content }}
        ></p>

        <div className="mt-2">
          <h2
            className="blogtitle   "
            onClick={handleToggle}
            style={{
              cursor: 'pointer',
              display: 'inline',
              alignItems: 'center',
            }}
          >
            {/* Title text */}
            <span
              className="border-b-2  border-[#2B3252]"
              style={{ flexGrow: 1 }}
            >
              Table of Content
            </span>

            {/* Arrow icon, rotated based on isExpanded */}
            <span
              className={`arrow  ${isExpanded ? 'rotate' : ''}`}
              style={{
                display: 'inline-block',
                marginLeft: '10px',
                transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.3s ease',
              }}
            >
              <IoIosArrowDown />
            </span>
          </h2>
          {isExpanded && (
            <div className="cardbg mb-4 pl-10 mt-3 pb-2 text-[#2B3252] text-[16px] font-normal pt-4 rounded">
              {dfwAirport.map((item, index) => {
                return (
                  <div key={index}>
                    {/* Title Section */}
                    {item.title && (
                      <p className="blogcontent inline-block">
                        <a href={`#${item.id}`} className="animated-link">
                          {item.title}
                        </a>
                      </p>
                    )}

                    {/* Title1 Section */}
                    {item.title1 && (
                      <p className="blogcontent">
                        <a
                          href={`#${item.id1 || item.id}`}
                          className="animated-link"
                        >
                          {item.title1}
                        </a>
                      </p>
                    )}

                    {/* Terminal List Section */}
                    {item.terminals && (
                      <ul>
                        {item.terminals.map((terminal, idx) => (
                          <li
                            key={idx}
                            // Unique ID for each terminal list item
                            className="list-disc blogcontent ml-4"
                          >
                            {/* Anchor linking terminal name with its ID */}
                            <a
                              href={`#${terminal.id}`}
                              className="animated-link"
                            >
                              {terminal.name}
                            </a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <h2 id={blogData.id} className="blogSubtitle mt-5">
          {blogData.title2}
        </h2>
        <p
          className="blogcontent"
          dangerouslySetInnerHTML={{ __html: blogData.content2 }}
        ></p>
        <p className="blogcontent">{blogData.content3}</p>
      </div>
    </>
  );
}

export default Hero;
